// operationalTrace - minimal, non-destructive tracing utility
// Generates trace objects for operational events (mock implementation)
import { v4 as uuidv4 } from 'uuid';

// Try to POST traces to backend endpoint /api/traces but keep original
// console fallback behavior. Non-destructive: if backend fails, just log.
const BACKEND_TRACE_ENDPOINT = '/api/traces';

function isoNow() {
    return new Date().toISOString();
}

export function makeTrace({ eventType, operatorId, role, sessionId, sourceModule, details = {} }) {
    const trace = {
        eventId: `evt-${uuidv4()}`,
        eventType,
        utcTimestamp: isoNow(),
        localTimestamp: new Date().toString(),
        operatorId: operatorId || null,
        role: role || null,
        sessionId: sessionId || localStorage.getItem('reacta_sessionId') || null,
        sourceModule: sourceModule || 'unknown',
        details
    };
    // Console.log for now (structured)
    // In future this will forward to backend/telemetry pipeline
    // Use grouped logs for readability
    try {
        console.groupCollapsed('[TRACE] ' + trace.eventType + ' — ' + trace.eventId);
        console.log(trace);
        console.groupEnd();
    } catch (e) {
        console.log('[TRACE]', trace);
    }

    // Attempt to send trace to backend, but don't break app if fails.
    try {
        // Fire-and-forget; frontend must remain resilient
        const { sessionId: traceSessionId, ...traceBody } = trace;
        fetch(BACKEND_TRACE_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...(traceSessionId ? { 'x-session-id': traceSessionId } : {}) },
            body: JSON.stringify(traceBody),
            keepalive: true
        }).then(res => {
            if (!res.ok) {
                // don't throw, but log for diagnostics
                console.warn('[TRACE][BACKEND] non-ok response', res.status);
            }
        }).catch(err => {
            // expected in offline/fallback scenarios
            console.debug('[TRACE][BACKEND] send failed (expected in offline/fallback)', err?.message || err);
        });
    } catch (e) {
        // extremely defensive: keep UI working
        console.debug('[TRACE][BACKEND] exception while sending', e?.message || e);
    }

    return trace;
}

export default { makeTrace };
